import { render, staticRenderFns } from "./AwardTypeList.vue?vue&type=template&id=45e0fa26&scoped=true"
import script from "./AwardTypeList.vue?vue&type=script&lang=js"
export * from "./AwardTypeList.vue?vue&type=script&lang=js"
import style0 from "./AwardTypeList.vue?vue&type=style&index=0&id=45e0fa26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e0fa26",
  null
  
)

export default component.exports